module.exports = __webpack_public_path__ + "media/src/images/icons/icons8-worker-8cbdebad37bfc4068f61a0dea6ab5d1e.png";